import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component, inject,
    OnChanges,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ViewEncapsulation
} from "@angular/core";
import {Subject, takeUntil} from "rxjs";
import {
    MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogRef
} from "@angular/material/dialog";
import {TranslocoPipe} from "@ngneat/transloco";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {NgIf} from "@angular/common";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {YoutubeVideoComponent} from "../../../shared/components/youtube-video/youtube-video.component";


@Component({
    selector     : 'smm-learning-step-viewer',
    templateUrl  : './learning-step-viewer-component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone   : true,
    imports: [
        TranslocoPipe,
        MatDialogContent,
        MatDialogActions,
        MatDialogClose,
        MatDialogModule,
        MatFormField,
        MatLabel,
        MatError,
        MatSuffix,
        MatInput,
        FormsModule,
        MatDatepicker,
        MatDatepickerInput,
        MatDatepickerToggle,
        NgIf,
        MatButton,
        MatIconModule,
        MatIconButton,
        YoutubeVideoComponent
    ],
})
/** CHANGE CLASS NAME HERE **/
export class LearningStepViewerComponent implements OnChanges, OnInit, OnDestroy
{
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    readonly step:any = inject<any>(MAT_DIALOG_DATA);
    private readonly _dialogRef = inject(MatDialogRef<LearningStepViewerComponent>);

    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
    ) {}

    ngOnChanges(changes: SimpleChanges) {
        // if (changes.settings?.currentValue) {
        //
        // }
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    ngOnInit(): void {

    }
}
